import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import * as popper from '@popperjs/core';
import * as bootstrap from 'bootstrap';
import initPlayer from './components/player';

import initHome from './components/home';
import initStats from './components/stats';
import initHeader from './components/header';
import initTextAnims from './components/text-anims';
import initVideo from './components/video';
import initCarousel from './components/carousel';
import initSearch from './components/search';
import initGallery from './components/gallery';
import initItemCards from './components/item-cards';
import initParallaxScroll from './components/parallax-scroll';
import initPeople from './components/people';
import initInteractive from './components/interactive';
import initSelect from './components/select';
import initSolution from './components/solution';


gsap.registerPlugin(ScrollTrigger);

// Styles
import '../scss/styles.scss';
import 'swiper/swiper-bundle.css';

// -----------------------------
// Lenis
// -----------------------------
const lenis = new Lenis({
  smoothWheel: true,
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
});
window.lenis = lenis;

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

let statsCleanup;

// -----------------------------
// Helpers init
// -----------------------------
window.initTextAnims = initTextAnims;

function initPage() {
  // Pages
  if (document.querySelector('.hero__home')) initHome();

  // Text anims
  initTextAnims();

  // Components
  if (document.querySelector('.stats')) {
    statsCleanup = initStats();
  }
  if (document.querySelector('.video-block')) {
    initVideo();
  }
  if (document.querySelector('.carousel')) {
    initCarousel();
  }
  initHeader();
  initSearch();
  initGallery();
  initItemCards();
  initParallaxScroll();
  initPeople();
  initInteractive();
  initSelect();
  initSolution();



  // container
  const footerContainer = document.querySelector('.footer .container');
  if (footerContainer) {
    document.documentElement.style.setProperty(
      '--container-width',
      footerContainer.offsetWidth + 'px'
    );
  }
}


function afterPageMounted() {
  // Failsafe: if we are not on homepage, scroll MUST be enabled
  if (!document.querySelector('.hero__home')) {
    lenis.start();
  }

  // Ensure Lenis knows the new content height
  lenis.resize();

  try {
    lenis.scrollTo(0, { immediate: true });
  } catch (e) {
    window.scrollTo(0, 0);
  }

  // Refresh ScrollTrigger to account for new page layout
  ScrollTrigger.refresh();

  const root = document.documentElement;
  function setVar() {
    const fc = document.querySelector('.footer .container');
    if (fc) root.style.setProperty('--container-width', fc.offsetWidth + 'px');
  }
  setVar();
  window.addEventListener('resize', setVar, { passive: true });
}
addEventListener("DOMContentLoaded", (event) => {
  // player
  initPlayer();

  initPage();
  afterPageMounted();

})
